import {
  IOccupationCard,
  OccupationCategory
} from '@cpd-app/core-module/models';
import { createAction, props } from '@ngrx/store';

export const loadOccupationCards = createAction(
  '[Occupation Cards] Load Occupation Cards'
);

export const loadOccupationCardsSuccess = createAction(
  '[Occupation Cards] Load Occupation Cards Success',
  props<{
    occupationCategories: OccupationCategory[];
    occupationCards: IOccupationCard[];
  }>()
);

export const loadOccupationCardsError = createAction(
  '[Occupation Cards] Load Occupation Cards Error'
);
